import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
import { jsx as _jsx } from "react/jsx-runtime";
var EyeClosedIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/_jsx(BaseSvg, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden,
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.805,2.694c-0.311,-0.312 -0.818,-0.312 -1.13,0l-12.485,12.487c-0.312,0.312 -0.312,0.819 0,1.13c0.312,0.312 0.817,0.312 1.13,0l12.485,-12.487c0.312,-0.312 0.312,-0.818 0,-1.13ZM3.492,12.296l2.044,-2.044c-0.055,-0.242 -0.09,-0.491 -0.09,-0.75c0,-1.9 1.59,-3.442 3.551,-3.442c0.229,0 0.451,0.026 0.668,0.066l0.96,-0.96c-0.514,-0.084 -1.053,-0.137 -1.628,-0.137c-5.241,0 -7.988,3.86 -7.988,4.473c0,0.339 0.844,1.671 2.483,2.794ZM14.506,6.71l-2.047,2.046c0.055,0.241 0.089,0.49 0.089,0.746c0,1.901 -1.589,3.441 -3.551,3.441c-0.226,0 -0.447,-0.025 -0.662,-0.065l-0.962,0.962c0.513,0.083 1.051,0.136 1.624,0.136c5.241,0 7.989,-3.862 7.989,-4.474c0,-0.339 -0.844,-1.669 -2.48,-2.792Z"
    })
  }));
});
EyeClosedIcon.displayName = 'EyeClosedIcon';
export default EyeClosedIcon;